import { onUnmounted } from "vue"

export function usePolling(fn: () => void | Promise<void>, interval = 5000) {
  let timer: number | null = null

  // 启动轮询
  const start = async () => {
    await stop() // 防止重复启动

    const run = async () => {
      await fn()
      timer = window.setTimeout(run, interval)
    }

    run()
  }

  // 停止轮询
  const stop = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  onUnmounted(() => {
    stop()
  })

  return {
    start,
    stop,
  }
}
